export default __webpack_public_path__ + "static/media/promos-icon.6a5c246b.webp";